module.exports = __webpack_public_path__ + "img/second-day-9.c29cfdea.webp";